import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const ProgramOutcomeBarChart = ({ names, averages }) => {
    /* names: [{id, name, order}] */

    /* 1) labels grafikte order’a göre */
    const sorted = [...names].sort((a, b) => a.order - b.order);

    const labels = sorted.map(n => n.order.toString());

    /* 2) order’a karşılık gelen puanlar */
    const dataVals = sorted.map(n =>
        averages.find(a => a.programOutcomeId === n.id)?.avgPoint ?? 0
    );

    const data = {
        labels,
        datasets: [{
            label: 'Puan',
            data: dataVals,
            borderWidth: 1
        }]
    };

    const options = {
        responsive: true,
        scales: { y: { min: 0, max: 10, ticks: { stepSize: 1 } } },
        plugins: {
            tooltip: {
                callbacks: {
                    /* tooltip başlığı: Order + tam ad */
                    title: ctx => {
                        const idx = ctx[0].dataIndex;
                        const n = sorted[idx];
                        return `PC-${n.order}: ${n.name}`;
                    }
                }
            },
            legend: { display: false }
        }
    };

    /* Legend */
    const legend = (
        <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
            {sorted.map(n => (
                <li key={n.id}>
                    <strong>{n.order}</strong> – {n.name}
                </li>
            ))}
        </ul>
    );

    return (
        <div className="row">
            <div className="col-md-4">{legend}</div>
            <div className="col-md-8">
                <Bar data={data} options={options} />
            </div>
        </div>
    );
};

export default ProgramOutcomeBarChart;
